// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es6.function.bind.js
 **/